import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage } from 'react-intl';
import { fromJS } from 'immutable';
import validator from 'validator';
import { uniqueId } from 'lodash';
import ReactResizeDetector from 'react-resize-detector';
import * as _ from 'lodash';
import moment from 'moment';
import injectReducer from 'utils/injectReducer';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import { makeSelectStepTravelDelay, makeSelectStepTravelDelayErrors } from './selectors';
import reducer from './reducer';
import messages from './messages';

import { Button } from '../components/Button';
import PageSectionHeader from '../components/PageSectionHeader';
import FlexBox from '../../../components/FlexBox';
import {
  ValidateGroup,
  Validate,
  ErrorMessage,
} from '../../../components/Validation';
import {
  handleFormDataChange,
  nextSlide,
  resetFormData,
  resetFormTravelDelay,
} from './actions';
import DatePicker from '../components/DatePicker/index';
import Textbox from '../components/Textbox';
import TextArea from '../components/TextArea';
import OptionsContainer from '../components/OptionsContainer';
import { CLAIMING_FOR } from './constants';
import { AdditionalList } from './components/Additional';
import { InsuredList } from './components/AddInsured';
import { saveFormData } from '../actions';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import AsyncButton from '../../../components/AsyncButton/index';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import TimePickerInput from '../../../components/TimePickerInput';
import { stepTravelDelayLookup } from '../../FastCover/dataMapper/claimCodeMapper';
import { required, checkDateOnly } from '../../../utils/validation/validator';
import { makeSelectJSONVersion, makeSelectIsClaimGroupAllowed, makeSelectInsuredsList, makeSelectIsClaimForFieldEnabled } from '../../App/selectors';
import HelpText from '../../../components/HelpText';
export class StepTravelDelay extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      errors: [],
      physicianEmail: false,
    };
    this.validatorGroup = new ValidateGroup();
    this.handleNext = this.handleNext.bind(this);
    this.checkFormError = this.checkFormError.bind(this);
    this.onResize = this.onResize.bind(this);

    this.saveButtonId = uniqueId();
    this.emailMeDocumentButton = _.uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }

  onChange = (propertyName) => (event) => {
    if (event === null) {
      this.props.onFormDataChange(propertyName, null);
      return;
    }

    if (event.constructor.name === 'Moment') {
      this.props.onFormDataChange(propertyName, removeTimeZoneFromDate(event.toDate().toString()));
    } else {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      if (target.type === 'radio') {
        this.props.adjust();
      }
      this.props.onFormDataChange(propertyName, value);
    }
    // this.props.makeDirty(6);
  };

  // Travel delay
  onDelayInformationItemsChange = (data) => {
    this.props.onFormDataChange('form.delayInformationItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onMissedConnectionInformationItemsChange = (data) => {
    this.props.onFormDataChange('form.missedConnectionInformationItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onResize = () => {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  getSelectedClaiming = () => {
    const {
      claimForPassportCreditCard,
      claimForTheftOfCash,
      claimForLuggageAndPersonalEffect,
    } = this.props.form;

    let selectedValue = null;

    switch ('true') {
      case claimForPassportCreditCard:
        selectedValue = CLAIMING_FOR.PASSPORT_CREDIT_CARD;
        break;
      case claimForTheftOfCash:
        selectedValue = CLAIMING_FOR.THEFT_OF_CASH;
        break;
      case claimForLuggageAndPersonalEffect:
        selectedValue = CLAIMING_FOR.LUGGAGE_AND_PERSONAL_EFFECTS;
        break;
      default:
        selectedValue = null;
        break;
    }

    return selectedValue;
  };

  shouldDisable = (field) => {
    const selectedValue = this.getSelectedClaiming();

    return !!selectedValue && selectedValue !== field;
  };

  appendIds = (array) =>
    array.map((item) => {
      let newItem = item; // eslint-disable-line
      if (!item.id) {
        newItem.id = new Date().getTime().toString();
      }
      return newItem;
    });

  validateTableField(groups) {
    const invalid = _.some(groups, (fields) =>
      _.some(fields, (value) => {
        const newValue = value ? value.toString() : '';
        return validator.isEmpty(newValue);
      })
    );
    return invalid;
  }

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  handleChangePhoneNumber = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^[0-9-]+$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value) || value === '') {
      this.props.onFormDataChange(propertyName, value);
    }
  };

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.onFormDataSave();
    this.nextButton.focus();
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  checkFormError() {
    const {
      travelDelay,
      missedConnection,
    } = this.props.form;
    const isSelectBenefit = travelDelay === 'true' || missedConnection === 'true';
    const valid = isSelectBenefit && this.validatorGroup.checkValidation();
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.props.onFormDataChange(propertyName, value);
  };

  handleNext = () => {
    const {
      travelDelay,
      missedConnection,
    } = this.props.form;
    const isSelectBenefit = travelDelay === 'true' || missedConnection === 'true';
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }

    // const errors = this.validatorGroup.getErrors();
    const valid = isSelectBenefit && this.validatorGroup.checkValidation();

    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }

    this.props.onFormDataSave();
    this.props.next();
  };

  handleFormDataSave = () => {
    this.props.onFormDataSave();
  };

  handleDayChange = (propertyName) => (day) => {
    const dayWithoutTimeZone = removeTimeZoneFromDate(day);
    this.props.onFormDataChange(propertyName, dayWithoutTimeZone);
    // this.props.makeDirty(6);
  };

  handleReasonsForDelay = (propertyName) => (event) => {
    const { reasonsForDelay } = this.props.form;
    const reasons = !!reasonsForDelay && typeof reasonsForDelay.toJS === 'function'
      ? reasonsForDelay.toJS()
      : reasonsForDelay || [];
    const listChecked = _.cloneDeep(reasons);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  handleReasonsForMissedConnection = (propertyName) => (event) => {
    const { reasonsForMissedConnection } = this.props.form;
    const reasons = !!reasonsForMissedConnection && typeof reasonsForMissedConnection.toJS === 'function'
      ? reasonsForMissedConnection.toJS()
      : reasonsForMissedConnection || [];
    const listChecked = _.cloneDeep(reasons);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  handleReasonsForTripInterruption = (propertyName) => (event) => {
    const { reasonsForTripInterruption } = this.props.form;
    const reasons = !!reasonsForTripInterruption && typeof reasonsForTripInterruption.toJS === 'function'
      ? reasonsForTripInterruption.toJS()
      : reasonsForTripInterruption || [];
    const listChecked = _.cloneDeep(reasons);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }

  handleUncheckedFormState = (field, resetAction) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    if (value === 'false') {
      resetAction();
    }

    this.handleChange(field)(event);
  };

  // Travel Delay
  renderTravelDelay() {
    const {
      travelDelay,
      reasonsForDelay,
      dateYouWereDueToDepart,
      timeYouWereDueToDepart,
      dateTripWasDelayed,
      dateDelayEnded,
      dateYouActuallyDeparted,
      timeYouActuallyDeparted,
      detailsRegardingYourTripDelay,
      didTheDelayOccurDuringDeparture,
      scheduledDateOfDeparture,
      scheduledTimeOfDeparture,
      didTheDelayOccurDuringArrival,
      scheduledDateOfArrival,
      scheduledTimeOfArrival,
      actualDateOfDeparture,
      actualTimeOfDeparture,
      actualDateOfArrival,
      actualTimeOfArrival,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const newTimeYouWereDueToDepart = timeYouWereDueToDepart ? moment(timeYouWereDueToDepart) : null;
    const newTimeYouActuallyDeparted = timeYouActuallyDeparted ? moment(timeYouActuallyDeparted) : null;
    const newScheduledTimeOfDeparture = scheduledTimeOfDeparture ? moment(scheduledTimeOfDeparture) : null;
    const newActualTimeOfDeparture = actualTimeOfDeparture ? moment(actualTimeOfDeparture) : null;
    const newScheduledTimeOfArrival = scheduledTimeOfArrival ? moment(scheduledTimeOfArrival) : null;
    const newActualTimeOfArrival = actualTimeOfArrival ? moment(actualTimeOfArrival) : null;
    const { isSummary, submitted, jsonVersion, isClaimGroupAllowed } = this.props;
    const reasonsForDelays = !!reasonsForDelay && typeof reasonsForDelay.toJS === 'function'
      ? reasonsForDelay.toJS()
      : reasonsForDelay || [];
    const isReadOnly = submitted || isSummary;
    const displayOldField = jsonVersion < 6;
    return (
      travelDelay === 'true' && (
        <div>
          <div className={'ml-3'}>
            <div className={'col-sm-12 form-group'}>
              <Validate
                    name="reasonsForDelay"
                    validators={[required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={reasonsForDelays}
                    fieldName={messages.reasonsForDelay}
                  >
                    <div className={'col-sm-12 form-group'}>
                      <input
                        disabled={isReadOnly}
                        type="checkbox"
                        name="Reasons1"
                        checked={reasonsForDelays.includes('Reasons1')}
                        onChange={this.handleReasonsForDelay('form.reasonsForDelay')}
                      />
                      <span>
                        <FormattedMessage {...messages.reasons1ForTravelDelay} />
                      </span>
                    </div>
                    <div className={'col-sm-12 form-group'}>
                      <input
                        disabled={isReadOnly}
                        type="checkbox"
                        name="Reasons2"
                        checked={reasonsForDelays.includes('Reasons2')}
                        onChange={this.handleReasonsForDelay('form.reasonsForDelay')}
                      />
                      <span>
                        <FormattedMessage {...messages.reasons2ForTravelDelay} />
                      </span>
                    </div>
                    <div className={'col-sm-12 form-group'}>
                      <input
                        disabled={isReadOnly}
                        type="checkbox"
                        name="Reasons3"
                        checked={reasonsForDelays.includes('Reasons3')}
                        onChange={this.handleReasonsForDelay('form.reasonsForDelay')}
                      />
                      <span>
                        <FormattedMessage {...messages.reasons3ForTravelDelay} />
                      </span>
                    </div>
                    <div className={'col-sm-12 form-group'}>
                      <input
                        disabled={isReadOnly}
                        type="checkbox"
                        name="Reasons4"
                        checked={reasonsForDelays.includes('Reasons4')}
                        onChange={this.handleReasonsForDelay('form.reasonsForDelay')}
                      />
                      <span>
                        <FormattedMessage {...messages.reasons4ForTravelDelay} />
                      </span>
                    </div>
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.reasonsForDelay}
                      />
                    </ErrorMessage>
              </Validate>
            </div>
          </div>
          <div className={'ml-3'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.delayInformation} />
            </PageSectionHeader>
          </div>
          <div className={'ml-3'}>
            <div className={'form-group col-sm-12'}>
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="didTheDelayOccurDuringDeparture"
                  checked={didTheDelayOccurDuringDeparture === true}
                  onChange={this.handleChange('form.didTheDelayOccurDuringDeparture')}
                />
                <span>
                  <FormattedMessage {...messages.didTheDelayOccurDuringDeparture} />
                </span>
                { didTheDelayOccurDuringDeparture === true &&
                  <div>
                    <div className="row">
                      <div className="form-group col-md-6 col-sm-6">
                          <Validate
                            name="scheduledDateOfDeparture"
                            validators={[checkDateOnly, required]}
                            group={this.validatorGroup}
                            addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                            validChangeInGroup={this.validatorGroup.validChangeInGroup}
                            validationCounter={this.state.validationCounter}
                            validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                            defaultValue={scheduledDateOfDeparture}
                            fieldName={messages.scheduledDateOfDeparture}
                          >
                            <DatePicker
                              position={'bottom-start'}
                              disabled={isReadOnly}
                              name="scheduledDateOfDeparture"
                              type="text"
                              onDayChange={this.handleDayChange('form.scheduledDateOfDeparture')}
                              value={scheduledDateOfDeparture}
                            />
                            <ErrorMessage for="required">
                              <FormattedMessage
                                {...messages.isRequired}
                                values={messages.scheduledDateOfDeparture}
                              />
                            </ErrorMessage>
                            <ErrorMessage for="checkDateOnly">
                              <FormattedMessage
                                {...messages.checkEventDate}
                                values={messages.scheduledDateOfDeparture}
                              />
                            </ErrorMessage>
                          </Validate>
                      </div>
                      <div className="form-group col-md-6 col-sm-6">
                          <Validate
                            validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                            name="scheduledTimeOfDeparture"
                            group={this.validatorGroup}
                            validators={[required]}
                            addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                            validChangeInGroup={this.validatorGroup.validChangeInGroup}
                            validationCounter={this.state.validationCounter}
                            defaultValue={newScheduledTimeOfDeparture}
                            fieldName={messages.scheduledTimeOfDeparture}
                          >
                            <TimePickerInput
                              allowEmpty
                              showSecond={false}
                              onChange={this.onChange('form.scheduledTimeOfDeparture')}
                              value={newScheduledTimeOfDeparture}
                              disabled={isReadOnly}
                            />
                            <ErrorMessage for="required">
                              <FormattedMessage
                                {...messages.isRequired}
                                values={messages.scheduledTimeOfDeparture}
                              />
                            </ErrorMessage>
                          </Validate>
                      </div>
                    </div>
                    <div className="row">
                      <div className="form-group col-md-6 col-sm-6">
                          <Validate
                            name="actualDateOfDeparture"
                            validators={[checkDateOnly, required]}
                            group={this.validatorGroup}
                            addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                            validChangeInGroup={this.validatorGroup.validChangeInGroup}
                            validationCounter={this.state.validationCounter}
                            validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                            defaultValue={actualDateOfDeparture}
                            fieldName={messages.actualDateOfDeparture}
                          >
                            <DatePicker
                              position={'bottom-start'}
                              disabled={isReadOnly}
                              name="actualDateOfDeparture"
                              type="text"
                              onDayChange={this.handleDayChange('form.actualDateOfDeparture')}
                              value={actualDateOfDeparture}
                            />
                            <ErrorMessage for="required">
                              <FormattedMessage
                                {...messages.isRequired}
                                values={messages.actualDateOfDeparture}
                              />
                            </ErrorMessage>
                            <ErrorMessage for="checkDateOnly">
                              <FormattedMessage
                                {...messages.checkEventDate}
                                values={messages.actualDateOfDeparture}
                              />
                            </ErrorMessage>
                          </Validate>
                      </div>
                      <div className="form-group col-md-6 col-sm-6">
                          <Validate
                            validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                            name="actualTimeOfDeparture"
                            group={this.validatorGroup}
                            validators={[required]}
                            addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                            validChangeInGroup={this.validatorGroup.validChangeInGroup}
                            validationCounter={this.state.validationCounter}
                            defaultValue={newActualTimeOfDeparture}
                            fieldName={messages.actualTimeOfDeparture}
                          >
                            <TimePickerInput
                              allowEmpty
                              showSecond={false}
                              onChange={this.onChange('form.actualTimeOfDeparture')}
                              value={newActualTimeOfDeparture}
                              disabled={isReadOnly}
                            />
                            <ErrorMessage for="required">
                              <FormattedMessage
                                {...messages.isRequired}
                                values={messages.actualTimeOfDeparture}
                              />
                            </ErrorMessage>
                          </Validate>
                      </div>
                    </div>
                  </div>
                }
            </div>
            <div className={'form-group col-sm-12'}>
              <input
                disabled={isReadOnly}
                type="checkbox"
                name="didTheDelayOccurDuringArrival"
                checked={didTheDelayOccurDuringArrival === true}
                onChange={this.handleChange('form.didTheDelayOccurDuringArrival')}
              />
              <span>
                <FormattedMessage {...messages.didTheDelayOccurDuringArrival} />
              </span>
              { didTheDelayOccurDuringArrival === true &&
              <div>
                <div className="row">
                  <div className="form-group col-md-6 col-sm-6">
                      <Validate
                        name="scheduledDateOfArrival"
                        validators={[checkDateOnly, required]}
                        group={this.validatorGroup}
                        addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                        validChangeInGroup={this.validatorGroup.validChangeInGroup}
                        validationCounter={this.state.validationCounter}
                        validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                        defaultValue={scheduledDateOfArrival}
                        fieldName={messages.scheduledDateOfArrival}
                      >
                        <DatePicker
                          position={'bottom-start'}
                          disabled={isReadOnly}
                          name="scheduledDateOfArrival"
                          type="text"
                          onDayChange={this.handleDayChange('form.scheduledDateOfArrival')}
                          value={scheduledDateOfArrival}
                        />
                        <ErrorMessage for="required">
                          <FormattedMessage
                            {...messages.isRequired}
                            values={messages.scheduledDateOfArrival}
                          />
                        </ErrorMessage>
                        <ErrorMessage for="checkDateOnly">
                          <FormattedMessage
                            {...messages.checkEventDate}
                            values={messages.scheduledDateOfArrival}
                          />
                        </ErrorMessage>
                      </Validate>
                  </div>
                  <div className="form-group col-md-6 col-sm-6">
                      <Validate
                        validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                        name="scheduledTimeOfDeparture"
                        group={this.validatorGroup}
                        validators={[required]}
                        addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                        validChangeInGroup={this.validatorGroup.validChangeInGroup}
                        validationCounter={this.state.validationCounter}
                        defaultValue={newScheduledTimeOfArrival}
                        fieldName={messages.scheduledTimeOfArrival}
                      >
                        <TimePickerInput
                          allowEmpty
                          showSecond={false}
                          onChange={this.onChange('form.scheduledTimeOfArrival')}
                          value={newScheduledTimeOfArrival}
                          disabled={isReadOnly}
                        />
                        <ErrorMessage for="required">
                          <FormattedMessage
                            {...messages.isRequired}
                            values={messages.scheduledTimeOfArrival}
                          />
                        </ErrorMessage>
                      </Validate>
                  </div>
                </div>
                <div className="row">
                  <div className="form-group col-md-6 col-sm-6">
                      <Validate
                        name="actualDateOfArrival"
                        validators={[checkDateOnly, required]}
                        group={this.validatorGroup}
                        addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                        validChangeInGroup={this.validatorGroup.validChangeInGroup}
                        validationCounter={this.state.validationCounter}
                        validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                        defaultValue={actualDateOfArrival}
                        fieldName={messages.actualDateOfArrival}
                      >
                        <DatePicker
                          position={'bottom-start'}
                          disabled={isReadOnly}
                          name="actualDateOfArrival"
                          type="text"
                          onDayChange={this.handleDayChange('form.actualDateOfArrival')}
                          value={actualDateOfArrival}
                        />
                        <ErrorMessage for="required">
                          <FormattedMessage
                            {...messages.isRequired}
                            values={messages.actualDateOfArrival}
                          />
                        </ErrorMessage>
                        <ErrorMessage for="checkDateOnly">
                          <FormattedMessage
                            {...messages.checkEventDate}
                            values={messages.actualDateOfArrival}
                          />
                        </ErrorMessage>
                      </Validate>
                  </div>
                  <div className="form-group col-md-6 col-sm-6">
                      <Validate
                        validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                        name="actualTimeOfArrival"
                        group={this.validatorGroup}
                        validators={[required]}
                        addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                        validChangeInGroup={this.validatorGroup.validChangeInGroup}
                        validationCounter={this.state.validationCounter}
                        defaultValue={newActualTimeOfArrival}
                        fieldName={messages.actualTimeOfArrival}
                      >
                        <TimePickerInput
                          allowEmpty
                          showSecond={false}
                          onChange={this.onChange('form.actualTimeOfArrival')}
                          value={newActualTimeOfArrival}
                          disabled={isReadOnly}
                        />
                        <ErrorMessage for="required">
                          <FormattedMessage
                            {...messages.isRequired}
                            values={messages.actualTimeOfArrival}
                          />
                        </ErrorMessage>
                      </Validate>
                  </div>
                </div>
              </div>
              }
            </div>            
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                  <Validate
                    name="detailsRegardingYourTripDelay"
                    validators={[required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={detailsRegardingYourTripDelay}
                    fieldName={messages.detailsRegardingYourTripDelay}                  
                    >
                      <TextArea
                        name="detailsRegardingYourTripDelay"
                        type="text"
                        onChange={this.handleChange('form.detailsRegardingYourTripDelay')}
                        value={detailsRegardingYourTripDelay}
                        disabled={isReadOnly}
                      />
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={messages.detailsRegardingYourTripDelay}
                        />
                      </ErrorMessage>
                    </Validate>
              </div>
            </div>
          </div>
          {displayOldField && <div className="row">
              <div className="form-group col-md-6 col-sm-6">
                <Validate
                  name="dateYouWereDueToDepart"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateYouWereDueToDepart}
                  fieldName={messages.dateYouWereDueToDepart}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateYouWereDueToDepart"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateYouWereDueToDepart')}
                    value={dateYouWereDueToDepart}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateYouWereDueToDepart}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateYouWereDueToDepart}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className="form-group col-md-4 col-sm-4">
                <Validate
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  name="timeYouWereDueToDepart"
                  group={this.validatorGroup}
                  validators={[required]}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  defaultValue={newTimeYouWereDueToDepart}
                  fieldName={messages.timeYouWereDueToDepart}
                >
                  <TimePickerInput
                    allowEmpty
                    showSecond={false}
                    onChange={this.onChange('form.timeYouWereDueToDepart')}
                    value={newTimeYouWereDueToDepart}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.timeYouWereDueToDepart}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-md-2 col-sm-2 form-group'}>
              </div>
          </div>}
          {displayOldField && <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="dateTripWasDelayed"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateTripWasDelayed}
                  fieldName={messages.dateTripWasDelayed}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateTripWasDelayed"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateTripWasDelayed')}
                    value={dateTripWasDelayed}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateTripWasDelayed}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateTripWasDelayed}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="dateDelayEnded"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateDelayEnded}
                  fieldName={messages.dateDelayEnded}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateDelayEnded"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateDelayEnded')}
                    value={dateDelayEnded}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateDelayEnded}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateDelayEnded}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-2 form-group'}>
              </div>
          </div>}
          {displayOldField && <div className="row">
              <div className="form-group col-md-6 col-sm-6">
                <Validate
                  name="dateYouActuallyDeparted"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateYouActuallyDeparted}
                  fieldName={messages.dateYouActuallyDeparted}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateYouActuallyDeparted"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateYouActuallyDeparted')}
                    value={dateYouActuallyDeparted}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateYouActuallyDeparted}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateYouActuallyDeparted}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className="form-group col-md-4 col-sm-4">
                <Validate
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  name="timeYouActuallyDeparted"
                  group={this.validatorGroup}
                  validators={[required]}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  defaultValue={newTimeYouActuallyDeparted}
                  fieldName={messages.timeYouActuallyDeparted}
                >
                  <TimePickerInput
                    allowEmpty
                    showSecond={false}
                    onChange={this.onChange('form.timeYouActuallyDeparted')}
                    value={newTimeYouActuallyDeparted}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.timeYouActuallyDeparted}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-md-2 col-sm-2 form-group'}>
              </div>
          </div>}
          { isClaimGroupAllowed &&
            <div className={'ml-3 row'}>
              <div className={'col-sm-12'}>
                <HelpText>
                The amount you claim below is PER MEMBER. It needs to be an EQUAL amount claimed, for each person you selected in the page “What Happened”.
                If you want to claim DIFFERENT amounts for each person, please create a SEPARATE CLAIM per person.
                </HelpText>
              </div>
            </div>
          }
          <div className={'ml-3 mt-3'}>
            <PageSectionHeader>
              <FormattedMessage
                {...(isClaimGroupAllowed ? messages.lossInformationPerPerson : messages.lossInformation)}
              />
            </PageSectionHeader>
            {this.renderTravelDelayInformationItems()}
          </div>      
        </div>
      )
    );
  }

  renderTravelDelayInformationItems() {
    const { delayInformationItems } = this.props.form;
    const newDelayInformationItems = this.appendIds(delayInformationItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newDelayInformationItems}
          onChange={this.onDelayInformationItemsChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  // Missed Connection
  renderMissedConnection() {
    const {
      missedConnection,
      reasonsForMissedConnection,
      scheduledDateOfDepartureForMissedConnection,
      scheduledTimeOfDepartureForMissedConnection,
      scheduledDateOfArrivalForMissedConnection,
      scheduledTimeOfArrivalForMissedConnection,
      didTheDelayOccurDuringDepartureForMissedConnection,
      didTheDelayOccurDuringArrivalForMissedConnection,
      detailsRegardingYourMissedConnection,
      actualDateOfDeparturForMissedConnection,
      actualTimeOfDepartureForMissedConnection,
      actualDateOfArrivalForMissedConnection,
      actualTimeOfArrivalForMissedConnection,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const newScheduledTimeOfDeparture = scheduledTimeOfDepartureForMissedConnection ? moment(scheduledTimeOfDepartureForMissedConnection) : null;
    const newActualTimeOfDeparture = actualTimeOfDepartureForMissedConnection ? moment(actualTimeOfDepartureForMissedConnection) : null;
    const newScheduledTimeOfArrival = scheduledTimeOfArrivalForMissedConnection ? moment(scheduledTimeOfArrivalForMissedConnection) : null;
    const newActualTimeOfArrival = actualTimeOfArrivalForMissedConnection ? moment(actualTimeOfArrivalForMissedConnection) : null;
    const { isSummary, submitted, isClaimGroupAllowed } = this.props;
    const reasonsForMissedConnections = !!reasonsForMissedConnection && typeof reasonsForMissedConnection.toJS === 'function'
      ? reasonsForMissedConnection.toJS()
      : reasonsForMissedConnection || [];
    const isReadOnly = submitted || isSummary;
    return (
      missedConnection === 'true' && (
        <div>
          <div className={'ml-3'}>
            <div className={'col-sm-12 form-group'}>
                  <Validate
                    name="reasonsForDelay"
                    validators={[required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={reasonsForMissedConnections}
                    fieldName={messages.reasonsForMissedConnection}
                  >
                    <div className={'col-sm-12 form-group'}>
                      <input
                        disabled={isReadOnly}
                        type="checkbox"
                        name="Reasons1"
                        checked={reasonsForMissedConnections.includes('Reasons1')}
                        onChange={this.handleReasonsForMissedConnection('form.reasonsForMissedConnection')}
                      />
                      <span>
                        <FormattedMessage {...messages.reasons1ForTravelDelay} />
                      </span>
                    </div>
                    <div className={'col-sm-12 form-group'}>
                      <input
                        disabled={isReadOnly}
                        type="checkbox"
                        name="Reasons2"
                        checked={reasonsForMissedConnections.includes('Reasons2')}
                        onChange={this.handleReasonsForMissedConnection('form.reasonsForMissedConnection')}
                      />
                      <span>
                        <FormattedMessage {...messages.reasons2ForTravelDelay} />
                      </span>
                    </div>
                    <div className={'col-sm-12 form-group'}>
                      <input
                        disabled={isReadOnly}
                        type="checkbox"
                        name="Reasons3"
                        checked={reasonsForMissedConnections.includes('Reasons3')}
                        onChange={this.handleReasonsForMissedConnection('form.reasonsForMissedConnection')}
                      />
                      <span>
                        <FormattedMessage {...messages.reasons3ForTravelDelay} />
                      </span>
                    </div>
                    <div className={'col-sm-12 form-group'}>
                      <input
                        disabled={isReadOnly}
                        type="checkbox"
                        name="Reasons4"
                        checked={reasonsForMissedConnections.includes('Reasons4')}
                        onChange={this.handleReasonsForMissedConnection('form.reasonsForMissedConnection')}
                      />
                      <span>
                        <FormattedMessage {...messages.reasons4ForTravelDelay} />
                      </span>
                    </div>
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.reasonsForMissedConnection}
                      />
                    </ErrorMessage>
                  </Validate>
            </div>
          </div>
          <div className={'ml-3'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.missedConnectionInformation} />
            </PageSectionHeader>
          </div>
          <div className={'ml-3'}>
            <div className={'form-group col-sm-12'}>
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="didTheDelayOccurDuringDeparture"
                  checked={didTheDelayOccurDuringDepartureForMissedConnection === true}
                  onChange={this.handleChange('form.didTheDelayOccurDuringDepartureForMissedConnection')}
                />
                <span>
                  <FormattedMessage {...messages.didTheDelayOccurDuringDeparture} />
                </span>
                { didTheDelayOccurDuringDepartureForMissedConnection === true &&
                  <div>
                    <div className="row">
                      <div className="form-group col-md-6 col-sm-6">
                          <Validate
                            name="scheduledDateOfDeparture"
                            validators={[checkDateOnly, required]}
                            group={this.validatorGroup}
                            addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                            validChangeInGroup={this.validatorGroup.validChangeInGroup}
                            validationCounter={this.state.validationCounter}
                            validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                            defaultValue={scheduledDateOfDepartureForMissedConnection}
                            fieldName={messages.scheduledDateOfDeparture}
                          >
                            <DatePicker
                              position={'bottom-start'}
                              disabled={isReadOnly}
                              name="scheduledDateOfDeparture"
                              type="text"
                              onDayChange={this.handleDayChange('form.scheduledDateOfDepartureForMissedConnection')}
                              value={scheduledDateOfDepartureForMissedConnection}
                            />
                            <ErrorMessage for="required">
                              <FormattedMessage
                                {...messages.isRequired}
                                values={messages.scheduledDateOfDeparture}
                              />
                            </ErrorMessage>
                            <ErrorMessage for="checkDateOnly">
                              <FormattedMessage
                                {...messages.checkEventDate}
                                values={messages.scheduledDateOfDeparture}
                              />
                            </ErrorMessage>
                          </Validate>
                      </div>
                      <div className="form-group col-md-6 col-sm-6">
                          <Validate
                            validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                            name="scheduledTimeOfDeparture"
                            group={this.validatorGroup}
                            validators={[required]}
                            addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                            validChangeInGroup={this.validatorGroup.validChangeInGroup}
                            validationCounter={this.state.validationCounter}
                            defaultValue={newScheduledTimeOfDeparture}
                            fieldName={messages.scheduledTimeOfDeparture}
                          >
                            <TimePickerInput
                              allowEmpty
                              showSecond={false}
                              onChange={this.onChange('form.scheduledTimeOfDepartureForMissedConnection')}
                              value={newScheduledTimeOfDeparture}
                              disabled={isReadOnly}
                            />
                            <ErrorMessage for="required">
                              <FormattedMessage
                                {...messages.isRequired}
                                values={messages.scheduledTimeOfDeparture}
                              />
                            </ErrorMessage>
                          </Validate>
                      </div>
                    </div>
                    <div className="row">
                      <div className="form-group col-md-6 col-sm-6">
                          <Validate
                            name="actualDateOfDeparture"
                            validators={[checkDateOnly, required]}
                            group={this.validatorGroup}
                            addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                            validChangeInGroup={this.validatorGroup.validChangeInGroup}
                            validationCounter={this.state.validationCounter}
                            validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                            defaultValue={actualDateOfDeparturForMissedConnection}
                            fieldName={messages.actualDateOfDeparture}
                          >
                            <DatePicker
                              position={'bottom-start'}
                              disabled={isReadOnly}
                              name="actualDateOfDeparture"
                              type="text"
                              onDayChange={this.handleDayChange('form.actualDateOfDeparturForMissedConnection')}
                              value={actualDateOfDeparturForMissedConnection}
                            />
                            <ErrorMessage for="required">
                              <FormattedMessage
                                {...messages.isRequired}
                                values={messages.actualDateOfDeparture}
                              />
                            </ErrorMessage>
                            <ErrorMessage for="checkDateOnly">
                              <FormattedMessage
                                {...messages.checkEventDate}
                                values={messages.actualDateOfDeparture}
                              />
                            </ErrorMessage>
                          </Validate>
                      </div>
                      <div className="form-group col-md-6 col-sm-6">
                          <Validate
                            validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                            name="actualTimeOfDeparture"
                            group={this.validatorGroup}
                            validators={[required]}
                            addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                            validChangeInGroup={this.validatorGroup.validChangeInGroup}
                            validationCounter={this.state.validationCounter}
                            defaultValue={newActualTimeOfDeparture}
                            fieldName={messages.actualTimeOfDeparture}
                          >
                            <TimePickerInput
                              allowEmpty
                              showSecond={false}
                              onChange={this.onChange('form.actualTimeOfDepartureForMissedConnection')}
                              value={newActualTimeOfDeparture}
                              disabled={isReadOnly}
                            />
                            <ErrorMessage for="required">
                              <FormattedMessage
                                {...messages.isRequired}
                                values={messages.actualTimeOfDeparture}
                              />
                            </ErrorMessage>
                          </Validate>
                      </div>
                    </div>
                  </div>
                }
            </div>
            <div className={'form-group col-sm-12'}>
              <input
                disabled={isReadOnly}
                type="checkbox"
                name="didTheDelayOccurDuringArrival"
                checked={didTheDelayOccurDuringArrivalForMissedConnection === true}
                onChange={this.handleChange('form.didTheDelayOccurDuringArrivalForMissedConnection')}
              />
              <span>
                <FormattedMessage {...messages.didTheDelayOccurDuringArrival} />
              </span>
              { didTheDelayOccurDuringArrivalForMissedConnection === true &&
                <div>
                  <div className="row">
                    <div className="form-group col-md-6 col-sm-6">
                        <Validate
                          name="scheduledDateOfArrival"
                          validators={[checkDateOnly, required]}
                          group={this.validatorGroup}
                          addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                          validChangeInGroup={this.validatorGroup.validChangeInGroup}
                          validationCounter={this.state.validationCounter}
                          validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                          defaultValue={scheduledDateOfArrivalForMissedConnection}
                          fieldName={messages.scheduledDateOfArrival}
                        >
                          <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="scheduledDateOfArrival"
                            type="text"
                            onDayChange={this.handleDayChange('form.scheduledDateOfArrivalForMissedConnection')}
                            value={scheduledDateOfArrivalForMissedConnection}
                          />
                          <ErrorMessage for="required">
                            <FormattedMessage
                              {...messages.isRequired}
                              values={messages.scheduledDateOfArrival}
                            />
                          </ErrorMessage>
                          <ErrorMessage for="checkDateOnly">
                            <FormattedMessage
                              {...messages.checkEventDate}
                              values={messages.scheduledDateOfArrival}
                            />
                          </ErrorMessage>
                        </Validate>
                    </div>
                    <div className="form-group col-md-6 col-sm-6">
                        <Validate
                          validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                          name="scheduledTimeOfDeparture"
                          group={this.validatorGroup}
                          validators={[required]}
                          addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                          validChangeInGroup={this.validatorGroup.validChangeInGroup}
                          validationCounter={this.state.validationCounter}
                          defaultValue={newScheduledTimeOfArrival}
                          fieldName={messages.scheduledTimeOfArrival}
                        >
                          <TimePickerInput
                            allowEmpty
                            showSecond={false}
                            onChange={this.onChange('form.scheduledTimeOfArrivalForMissedConnection')}
                            value={newScheduledTimeOfArrival}
                            disabled={isReadOnly}
                          />
                          <ErrorMessage for="required">
                            <FormattedMessage
                              {...messages.isRequired}
                              values={messages.scheduledTimeOfArrival}
                            />
                          </ErrorMessage>
                        </Validate>
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col-md-6 col-sm-6">
                        <Validate
                          name="actualDateOfArrival"
                          validators={[checkDateOnly, required]}
                          group={this.validatorGroup}
                          addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                          validChangeInGroup={this.validatorGroup.validChangeInGroup}
                          validationCounter={this.state.validationCounter}
                          validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                          defaultValue={actualDateOfArrivalForMissedConnection}
                          fieldName={messages.actualDateOfArrival}
                        >
                          <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="actualDateOfArrival"
                            type="text"
                            onDayChange={this.handleDayChange('form.actualDateOfArrivalForMissedConnection')}
                            value={actualDateOfArrivalForMissedConnection}
                          />
                          <ErrorMessage for="required">
                            <FormattedMessage
                              {...messages.isRequired}
                              values={messages.actualDateOfArrival}
                            />
                          </ErrorMessage>
                          <ErrorMessage for="checkDateOnly">
                            <FormattedMessage
                              {...messages.checkEventDate}
                              values={messages.actualDateOfArrival}
                            />
                          </ErrorMessage>
                        </Validate>
                    </div>
                    <div className="form-group col-md-6 col-sm-6">
                        <Validate
                          validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                          name="actualTimeOfArrival"
                          group={this.validatorGroup}
                          validators={[required]}
                          addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                          validChangeInGroup={this.validatorGroup.validChangeInGroup}
                          validationCounter={this.state.validationCounter}
                          defaultValue={newActualTimeOfArrival}
                          fieldName={messages.actualTimeOfArrival}
                        >
                          <TimePickerInput
                            allowEmpty
                            showSecond={false}
                            onChange={this.onChange('form.actualTimeOfArrivalForMissedConnection')}
                            value={newActualTimeOfArrival}
                            disabled={isReadOnly}
                          />
                          <ErrorMessage for="required">
                            <FormattedMessage
                              {...messages.isRequired}
                              values={messages.actualTimeOfArrival}
                            />
                          </ErrorMessage>
                        </Validate>
                    </div>
                  </div>
                </div>
              }
            </div>            
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                  <Validate
                    name="detailsRegardingYourMissedConnection"
                    validators={[required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={detailsRegardingYourMissedConnection}
                    fieldName={messages.detailsRegardingYourMissedConnection}                  
                    >
                      <TextArea
                        name="detailsRegardingYourMissedConnection"
                        type="text"
                        onChange={this.handleChange('form.detailsRegardingYourMissedConnection')}
                        value={detailsRegardingYourMissedConnection}
                        disabled={isReadOnly}
                      />
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={messages.detailsRegardingYourMissedConnection}
                        />
                      </ErrorMessage>
                    </Validate>
              </div>
            </div>
          </div>
          { isClaimGroupAllowed &&
            <div className={'ml-3 row'}>
              <div className={'col-sm-12'}>
                <HelpText>
                The amount you claim below is PER MEMBER. It needs to be an EQUAL amount claimed, for each person you selected in the page “What Happened”.
                If you want to claim DIFFERENT amounts for each person, please create a SEPARATE CLAIM per person.
                </HelpText>
              </div>
            </div>
          }
          <div className={'ml-3 mt-3'}>
            <PageSectionHeader>
              <FormattedMessage
                {...(isClaimGroupAllowed ? messages.lossInformationPerPerson : messages.lossInformation)}
              />
            </PageSectionHeader>
            {this.renderMissedConnectionInformationItems()}
          </div>
        </div>
      )
    );
  }

  renderMissedConnectionInformationItems() {
    const { missedConnectionInformationItems } = this.props.form;
    const newMissedConnectionInformationItems = this.appendIds(missedConnectionInformationItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMissedConnectionInformationItems}
          onChange={this.onMissedConnectionInformationItemsChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  render() {
    const {
      travelDelay,
      missedConnection,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, loading } = this.props;
    const isRenderTravelDelay = !!stepTravelDelayLookup.travelDelay.claimCode;
    const isRenderMissedConnection = !!stepTravelDelayLookup.missedConnection.claimCode;
    const isReadOnly = submitted || isSummary;
    return (
      <div className="app-content">
        {isRenderTravelDelay &&
          <div className={'row'}>
            <div className={'col-sm-6 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.travelDelay} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={travelDelay === 'true'}
                    onChange={this.handleChange('form.travelDelay')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={travelDelay === 'false'}
                    onChange={this.handleChange('form.travelDelay')}
                    onClick={this.props.onResetFormTravelDelay}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>}
        {isRenderTravelDelay && this.renderTravelDelay()}
        {isRenderMissedConnection &&
          <div className={'row'}>
            <div className={'col-sm-6 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.missedConnection} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={missedConnection === 'true'}
                    onChange={this.handleChange('form.missedConnection')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={missedConnection === 'false'}
                    onChange={this.handleChange('form.missedConnection')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>}
        {isRenderMissedConnection && this.renderMissedConnection()}
        {!isSummary && (
          <div className={'row justify-content-between'}>
            <div className={'col-12 col-sm-auto'}>
              <div className={'row'}>
                <div className={'col-12 col-sm-auto'}>
                  <button
                    className="btn-outline"
                    onClick={this.props.prev}
                    onKeyDown={this.handleKeyDown}
                  >
                    Back
                  </button>
                </div>
                <div className={'col-12 col-sm-auto'}>
                  <Button
                    onClick={this.handleNext}
                    onKeyDown={this.handleKeyDown}
                    innerRef={(ref) => {
                      this.nextButton = ref;
                    }}
                  >
                    Next &gt;
                  </Button>
                </div>
              </div>
            </div>
            <div className={'col-12 col-sm-auto'}>
              {!submitted && (
                <AsyncButton
                  id={this.saveButtonId}
                  className="btn-outline"
                  loading={loading}
                  spinner={this.showSpinnerForElement(this.saveButtonId)}
                  onClick={this.handleSaveButtonClick}
                  onKeyDown={this.handleKeyDown}
                >
                  Save
                </AsyncButton>
              )}
            </div>
          </div>
        )}
        <ReactResizeDetector handleHeight onResize={this.onResize} />
      </div>
    );
  }
}

StepTravelDelay.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  prev: PropTypes.func,
  next: PropTypes.func,
  onFormDataSave: PropTypes.func,
  loading: PropTypes.bool,
  isSummary: PropTypes.bool,
  submitted: PropTypes.bool,
  adjust: PropTypes.func,
  makeValid: PropTypes.func,
  makeError: PropTypes.func,
  onNext: PropTypes.func,
  step: PropTypes.number,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isReadOnly: PropTypes.bool,
  errors: PropTypes.any,
  onResetFormTravelDelay: PropTypes.func,
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
  jsonVersion: PropTypes.string,
  isClaimGroupAllowed: PropTypes.bool,
  insuredsList: PropTypes.any,
  isClaimForFieldEnabled: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectStepTravelDelay(),
  errors: makeSelectStepTravelDelayErrors(),
  currentStep: makeSelectCurrentStep(),
  loading: makeSelectProgressBarStatus(),
  jsonVersion: makeSelectJSONVersion(),
  isClaimGroupAllowed: makeSelectIsClaimGroupAllowed(),
  insuredsList: makeSelectInsuredsList(),
  isClaimForFieldEnabled: makeSelectIsClaimForFieldEnabled(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) => dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
  onNext: (errors) => dispatch(nextSlide(errors)),
  onResetFormTravelDelay: () => dispatch(resetFormTravelDelay()),
  onResetFormData: () => dispatch(resetFormData()),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'stepTravelDelay', reducer });

export default compose(
  withReducer,
  withConnect
)(StepTravelDelay);



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepTravelDelay/index.js